import { render, staticRenderFns } from "./TestateOrdini.vue?vue&type=template&id=63295a58"
import script from "./TestateOrdini.vue?vue&type=script&lang=js"
export * from "./TestateOrdini.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports